export default __webpack_public_path__ + "static/media/setting.7d90aaee.svg";